import { CameraCircleOverlayTypes } from './CameraCircleOverlayTypes';
import './CameraCircleOverlayStyles.css';

export const CameraCircleOverlay = (props: CameraCircleOverlayTypes) => {
   const { ...restProps } = props;

   return (
      <div className="focus-overlay" {...restProps}/>
   );
};
